import { useEffect } from 'react';

import { Feedback } from '@playbooks/molecules/feedbacks';
import { Button } from '@playbooks/ui/components/button';
import { DialogHeader } from '@playbooks/ui/components/dialog';
import { Link } from '@playbooks/ui/components/link';
import { LoadingState } from '@playbooks/ui/components/loading-state';

import { useIntercom, useStore } from 'contexts';
import { useInit } from 'hooks';

const ReferralFlowProcessing = ({ model, referralCode, onClose, onView, onNext }) => {
	const intercom = useIntercom();
	const store = useStore();

	// Hooks
	useEffect(() => {
		if (referralCode) fetchData();
	}, [referralCode]);

	// Actions
	const [fetchData, loading] = useInit(async () => {
		await store.queryRecord({ url: `/referrer/${referralCode}/process` });
		onNext();
	});

	// Methods
	const onPrev = () => onView('welcome');
	const onSubmit = e => {
		e.preventDefault();
		intercom.toggle();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader />
			<div className='px-4 pb-8'>
				{loading ? (
					<LoadingState variant='modal' title='Hang tight!' message='Processing your order...' />
				) : (
					<Feedback
						layout='modal'
						icon='circle-xmark'
						title='Referral Failed'
						text={`Sorry, it looks like we ran into an issue processing that referral code. Please try again or contact support.`}
						variant='destructive'
						actions={
							<>
								<span className='w-1/2'>
									<Button onClick={onPrev} className='w-full'>
										Try again
									</Button>
								</span>
								<span className='w-1/2'>
									<Link variant='outline' href='/contact' target='_blank' className='w-full'>
										Contact Support
									</Link>
								</span>
							</>
						}
					/>
				)}
			</div>
		</form>
	);
};
export { ReferralFlowProcessing };
